import { PaymentStatuses, SessionPaymentStatuses } from "../../types/Balance";
import { PayRequestsStatuses } from "../../types/PayoutTypes";

export const getStatusesData = (s: { readonly [key: string]: string }) => {
  const statusesData = {
    [PaymentStatuses.FAILED]: {
      className: s.failed,
      title: "Failed",
    },
    [SessionPaymentStatuses.RETURNED]: {
      className: s.failed,
      title: "Returned",
    },
    [SessionPaymentStatuses.WAIT_FOR_RETURN]: {
      className: s.failed,
      title: "Waiting for refund",
    },
    [PayRequestsStatuses.FAILED]: {
      className: s.failed,
      title: "Failed",
    },
    [PayRequestsStatuses.CANCELED]: {
      className: s.failed,
      title: "Canceled",
    },
    [PayRequestsStatuses.REJECTED]: {
      className: s.failed,
      title: "Rejected",
    },
    [PayRequestsStatuses.PENDING]: {
      className: s.pending,
      title: "Pending",
    },
    [SessionPaymentStatuses.PENDING]: {
      className: s.pending,
      title: "Pending",
    },
    [PayRequestsStatuses.SUCCESS]: {
      className: s.succes,
      title: "Succeeded",
    },
    [SessionPaymentStatuses.SUCCEEDED]: {
      className: s.succes,
      title: "Succeeded",
    },
    [PayRequestsStatuses.NEW]: {
      className: s.new,
      title: "New",
    },
  };
  return statusesData;
};
